import ptBr from './pt-br';

export default { en: {}, 'pt-BR': ptBr };
